module.exports = __webpack_public_path__ + "img/7.115195e0.jpg";